import { render, staticRenderFns } from "./RPTReclamoClienteComponent.vue?vue&type=template&id=eebdbf6a&"
import script from "./RPTReclamoClienteComponent.vue?vue&type=script&lang=js&"
export * from "./RPTReclamoClienteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RPTReclamoClienteComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports